import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=81e7f636&"
import script from "./SiteList.vue?vue&type=script&lang=js&"
export * from "./SiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81e7f636')) {
      api.createRecord('81e7f636', component.options)
    } else {
      api.reload('81e7f636', component.options)
    }
    module.hot.accept("./SiteList.vue?vue&type=template&id=81e7f636&", function () {
      api.rerender('81e7f636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Site/SiteList/SiteList.vue"
export default component.exports